import { render } from "./SiteCloneModal.vue?vue&type=template&id=36d280e0&scoped=true&ts=true"
import script from "./SiteCloneModal.vue?vue&type=script&lang=ts"
export * from "./SiteCloneModal.vue?vue&type=script&lang=ts"

import "./SiteCloneModal.vue?vue&type=style&index=0&id=36d280e0&lang=scss&scoped=true"
import "./SiteCloneModal.vue?vue&type=style&index=1&id=36d280e0&lang=scss"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d280e0"]])

export default __exports__